module.exports = __webpack_public_path__ + "media/images/result_sets/circles/8r9r2n5n-1a459fb238c9645aebdaf0951a4ca128.svg";